import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Alert } from '@mui/material';
import { motion } from 'framer-motion';

const ChecklistEditor = () => {
  const [type, setType] = useState('');
  const [clauses, setClauses] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    try {
      const parsedClauses = JSON.parse(clauses);
      alert(`Checklist saved for ${type}: ${JSON.stringify(parsedClauses, null, 2)}`);
      setType('');
      setClauses('');
      setError('');
    } catch (e) {
      setError('Invalid JSON format.');
    }
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="primary" sx={{ mb: 3 }}>
          Edit Checklists
        </Typography>
        <TextField
          fullWidth
          label="Agreement Type (e.g., CDA)"
          value={type}
          onChange={(e) => setType(e.target.value)}
          sx={{ mb: 3, borderRadius: 2, backgroundColor: 'background.paper' }}
          margin="normal"
        />
        <TextField
          fullWidth
          multiline
          rows={6}
          label="Checklist JSON (e.g., [{clause: '...', preferred: '...', risk: '...'}])"
          value={clauses}
          onChange={(e) => setClauses(e.target.value)}
          sx={{ mb: 3, borderRadius: 2, backgroundColor: 'background.paper' }}
          margin="normal"
        />
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            background: 'linear-gradient(45deg, #1976d2, #7b1fa2)',
            '&:hover': { background: 'linear-gradient(45deg, #1565c0, #6a1b9a)' },
            borderRadius: 2,
          }}
        >
          Save Checklist
        </Button>
      </Box>
    </motion.div>
  );
};

export default ChecklistEditor;